module.exports = __webpack_public_path__ + "static/media/loanApplication.36c47316.svg";